import './faq.css';

const FAQS = [
    {
        q: 'What is Twigaa.ai?',
        a: "Twigaa.ai is an AI-powered end-to-end ERP software designed for travel operators to automate itinerary creation, costing, and client communications along with an inbuilt  CRM with an accounts addon — helping you save time and increase bookings.",
    },
    {
        q: 'Who is Twigaa.ai for?',
        a: 'Twigaa is built for Destination Management Companies (DMCs) / Travel Operators looking to digitize and streamline their operations.',
    },
    {
        q: 'How does the itinerary builder work?',
        a: 'Our smart itinerary builder lets you drag and drop components, personalize trips quickly, and generate beautiful, shareable proposals in minutes and share it with your end customer in the language of your choice with as a link, or as a PDF or even as a Word document via say whatsapp or email.',
    },
    {
        q: 'Does Twigaa.ai help increase bookings?',
        a: 'Absolutely. With faster turnaround, professional itineraries, and accurate pricing, our clients have seen up to 70% increase in confirmed bookings.',
    },
    {
        q: 'Can I use Twigaa.ai for team collaboration?',
        a: 'Yes, Twigaa is designed for teams. Assign tasks, track inquiries, and manage multiple client pipelines seamlessly in one place via our DMC specific in-built CRM',
    },
    {
        q: 'What makes Twigaa different from other travel CRMs?',
        a: 'Twigaa powers the CRM with the ability of itinerary building, auto costing, and automation all into one tool in addition to reports, accounts, P&L and other accounting reports, productivity reports including complete access-control rules — designed specifically for DMCs and travel businesses.',
    },
    {
        q: 'Can I try Twigaa.ai before subscribing?',
        a: 'Yes, we offer a free trial for one user id, so you can explore how Twigaa fits your workflow before making a commitment.',
    },
    {
        q: 'Is my data safe with Twigaa.ai?',
        a: 'Absolutely. We prioritize data privacy and use secure cloud infrastructure to keep all your business and client data protected.',
    },
    {
        q: 'Can I set different passenger (PAX) counts for different parks in one itinerary?',
        a: "Yes! With Twigaa.ai's advanced PAX configuration, you can assign different passenger counts for different parks or destinations within the same itinerary. This allows you to tailor experiences depending on whether it's a fixed group or a flexible group where certain people leave midway and certain people join midway.",
    },
    {
        q: 'How does Twigaa.ai handle per adult/child cost and cost analysis?',
        a: 'Twigaa provides per adult, child, infant, and youth cost breakdowns. You also get detailed cost analysis reports for each constituent part like separate for each hotel, each park, each safari vehicle etc and to the microtest level of each room, which gives complete clarity on pricing structure, margins, and profitability.',
    },
    {
        q: "Can I rename an itinerary after it's created?",
        a: 'Yes. Itineraries can be renamed anytime via the itinerary dashboard or during edits to maintain better organization.',
    },
    {
        q: 'Can I apply markups in bulk or in parts?',
        a: 'Yes, you can apply markups - Globally across the itinerary (whole) or Part-wise – adjust markup at a specific level (e.g., hotel, activity, transport) or even to an extent where you can set separate margins for separate hotels. You can also modify markups directly within the CRM module as needed. You can setup different markup for different agents too.',
    },
    {
        q: 'Can Twigaa.ai calculate costs automatically?',
        a: 'Yes! Twigaa auto-calculates all costs, including circuit discounts using our proprietary to-be-patented soon algorithms, and we are the first and the only one so far to digest all complex room rate policies, child policies, room occupancy policies and spit out the final cost if it satisfies all conditions — ensuring 100% speed, 99.99% accuracy and reducing manual errors.',
    },
    {
        q: 'Is training or onboarding support available?',
        a: 'Yes, we offer personalized onboarding and training to ensure your team can start using Twigaa effectively from day one.',
    },
    {
        q: 'Can I set markups specific to resorts or agents?',
        a: 'Absolutely. Resort-Specific Markup: Set custom markups for particular properties. Agent-Specific Markup: Assign markup levels for different agents (whole or part-based), tailored to their pricing structure.',
    },
    {
        q: 'What are circuit discounts and how do they work?',
        a: 'Circuit discounts are automatic reductions applied when booking multiple hotels or flights of a given hotel chain or a given flight operator. Twigaa.ai calculates eligible discounts in real-time, saving you time and increasing pricing accuracy.',
    },
    {
        q: 'Can I change passenger count, travel dates, or destination after creating the itinerary?',
        a: 'Yes. Use the "Recreate" feature to adjust pax, dates, or destinations even after an itinerary is created—without starting from scratch.',
    },
    {
        q: 'Can I generate and manage invoices within the platform?',
        a: 'Yes! Twigaa.ai allows you to create, manage, and download invoices, along with either general payment terms & details or agent-specific payment terms that auto-reflect during invoice generation.',
    },
    {
        q: 'Does Twigaa support multiple currencies and voucher generation?',
        a: 'Yes. We support multi-currency conversion for pricing (using dynamic forex conversion rates) and provide downloadable vouchers for hotels, flights, transfers, and more.',
    },
    {
        q: 'How is park entry and conservancy calculated?',
        a: 'Park and conservancy fees are calculated based on full PAX data, considering adult/child breakdowns and destination-specific entry rules.',
    },
];

const FAQPage = () => {
    return (
        <div className="body-div">
            <div className="faq-hero">
                <div className="wrap text-center">
                    <p className="eyebrow">Support</p>
                    <h1>Frequently Asked Questions</h1>
                    <p className="lede faq-hero-lede">
                        Everything operators ask us before, during, and after onboarding.
                    </p>
                </div>
            </div>

            <main className="wrap faq-body pb-5">
                <div className="faq-grid">
                    {FAQS.map((item, i) => (
                        <div className="faq-card" key={i}>
                            <span className="faq-mark">{i+1}</span>
                            <h3 className="faq-q">{item.q}</h3>
                            <p className="faq-a">{item.a}</p>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
};

export default FAQPage;